module.exports = __webpack_public_path__ + "img/dxImg.29cdbcae.jpg";